var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchived = function SvgArchived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M4.8 8.441a2 2 0 0 1-.351-.03 1.79 1.79 0 0 1-1.414-1.398C3 6.842 3 6.635 3 6.223c0-.414 0-.62.035-.792.142-.705.7-1.257 1.414-1.397C4.623 4 4.832 4 5.25 4h13.5c.418 0 .627 0 .801.034.714.14 1.272.692 1.414 1.397.035.172.035.378.035.791s0 .62-.035.791a1.79 1.79 0 0 1-1.414 1.397 2 2 0 0 1-.351.031m-9 4.448h3.6m-9-4.445h14.4v7.29c0 1.493 0 2.24-.294 2.81-.26.502-.672.91-1.18 1.165-.578.291-1.334.291-2.846.291H9.12c-1.512 0-2.268 0-2.846-.29a2.7 2.7 0 0 1-1.18-1.166c-.294-.57-.294-1.317-.294-2.81z"
  })));
};
export default SvgArchived;